import Table, { TableRow, TableCell } from '@amzn/meridian/table';
import React from 'react';
import { TranslationFunction } from '../../components/blocks';
import { TruncatedText } from '../../components/composites';
import { ResellerItem, SalesOrderDemandShipmentItem } from '../../redux/types';
import { findResellerItem } from '../../utils/resellerItemUtils';

export const AsinDetails = ({
    items,
    resellerItems,
    t,
}: {
    items: SalesOrderDemandShipmentItem[];
    resellerItems: ResellerItem[];
    t: TranslationFunction;
}) => {
    const sortedItems = [...items].sort((a, b) => b.shippedQuantity - a.shippedQuantity);

    return (
        <Table headerRows={1} showDividers={true}>
            <TableRow>
                <TableCell>{t('purchaseOrderListPage:asin-column')}</TableCell>
                <TableCell>{t('purchaseOrderListPage:retailerSku-column')}</TableCell>
                <TableCell>{t('purchaseOrderListPage:family-column')}</TableCell>
                <TableCell>{t('purchaseOrderListPage:productDescription-column')}</TableCell>
                <TableCell>{t('purchaseOrderListPage:unitsShipped-column')}</TableCell>
            </TableRow>
            {sortedItems.map((item) => {
                const resellerItem = findResellerItem(resellerItems, item.asin);
                return (
                    <TableRow key={item.asin} highlightOnHover={true}>
                        <TableCell>{item.asin}</TableCell>
                        <TableCell>{resellerItem?.externalSku || ''}</TableCell>
                        <TableCell>{resellerItem?.family || ''}</TableCell>
                        <TableCell>
                            <TruncatedText text={t.cognate(resellerItem?.title || '')} maxWidth={110} />
                        </TableCell>
                        <TableCell>{item.shippedQuantity}</TableCell>
                    </TableRow>
                );
            })}
        </Table>
    );
};
